module.exports = __webpack_public_path__ + "static/media/short-hit.621b116c.png";